// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-news-feed-edit-mobile-select-file-dialog-panel {
  width: 280px;
}
.fi-news-feed-edit-mobile-select-file-dialog-panel .mat-mdc-dialog-content {
  padding-left: 8px;
  padding-right: 8px;
}
.fi-news-feed-edit-mobile-select-file-dialog-panel .mat-mdc-dialog-actions {
  padding-bottom: 6px;
}
.fi-news-feed-edit-mobile-select-file-dialog-panel .mat-mdc-button {
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./Source/app/news-feed/edit-mobile/select-file-dialog/select-file-dialog.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;AACI;EACI,iBAAA;EACA,kBAAA;AACR;AAEI;EACI,mBAAA;AAAR;AAGI;EACI,gBAAA;AADR","sourcesContent":[".fi-news-feed-edit-mobile-select-file-dialog-panel {\r\n    width: 280px;\r\n\r\n    .mat-mdc-dialog-content {\r\n        padding-left: 8px;\r\n        padding-right: 8px;\r\n    }\r\n\r\n    .mat-mdc-dialog-actions {\r\n        padding-bottom: 6px;\r\n    }\r\n\r\n    .mat-mdc-button {\r\n        text-align: left;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
